export type TestimonialData = {
  organisation_website_link: string;
  organisation_offset_earth_username: string;
  organisation_name: string;
  person_name: string;
  testimony: string;
  image: {
    url: string;
    link: string;
    alt: string;
    icon?: string;
  };
};

export type TestimonialsData = {
  background_colour: string;
  testimonials: Array<TestimonialData>;
  title: string;
};
